module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "float-buttons-root"
  }, [_c('div', {
    staticClass: "icon-box message",
    on: {
      "click": _vm.onMessageButtonClick
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    staticClass: "icon-box reward",
    on: {
      "click": _vm.onRewardButtonClick
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fe59e06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/float-buttons/float-buttons.vue
// module id = 180
// module chunks = 0